import { createReducer } from '@reduxjs/toolkit';
import { actions } from './actions';
export const initialState = {
    isLoading: false,
    features: [],
    error: null,
};
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(actions.request, (state) => ({
        ...state,
        features: [],
        isLoading: true,
    }))
        .addCase(actions.success, (state, action) => ({
        ...state,
        features: action?.payload?.data,
        isLoading: false,
    }))
        .addCase(actions.failure, (state) => ({
        ...state,
        isLoading: false,
    }));
});
